





































































import Vue from 'vue'
import getStoriesPage from '~/apollo/queries/getStoriesPage.gql'
import getStoriesFeatured from '~/apollo/queries/getStoriesFeatured.gql'
import StoryGallery from '~/components/StoryGallery.vue'

export default Vue.extend({
  name: 'Stories',
  layout: 'stories',
  components: {
    StoryGallery
  },
  async fetch () {
    const getStoriesPageQuery = await this.$apolloProvider.defaultClient.query({
      query: getStoriesPage
    })
    this.pageData = getStoriesPageQuery.data.page[0]
    this.firstStory = getStoriesPageQuery.data.firstStory[0]
    this.otherStories = getStoriesPageQuery.data.otherStories

    const featuredStoriesQuery = await this.$apolloProvider.defaultClient.query({
      query: getStoriesFeatured
    })
    this.featuredStories = featuredStoriesQuery.data.stories
  },
  data () {
    return {
      pageData: null as any,
      firstStory: null,
      otherStories: null,
      featuredStories: null
    }
  },
  head (): any {
    return {
      title: this.pageData ? this.pageData.metaTitle : '',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageData ? this.pageData.metaDescription : ''
        }
      ]
    }
  }
})
